import { getSrcs } from '@helpers/image';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './SignpostCard.styles';
const SignpostCard = ({ content, cta, image, imgSizes, subtitle, title, video, }) => {
    const srcs = image ? getSrcs(image, 601, 251, 6, 454 / 836) : [];
    return (React.createElement(S.Container, null,
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Link, { ...(cta?.url
                    ? {
                        as: 'a',
                        href: cta.url,
                        title: cta.text,
                        target: cta.target,
                    }
                    : {}), "data-is-link": !!cta?.url },
                React.createElement(S.ImageWrapper, null,
                    image && (React.createElement(S.Image, { sizes: imgSizes, src: srcs[0].split(' ')[0], srcSet: srcs.join(','), role: !image.altText ? 'presentation' : undefined, loading: "lazy", alt: image.altText })),
                    video && React.createElement(S.MediaEmbedWrapper, { media: video })),
                title && React.createElement(S.Title, null, title),
                subtitle && React.createElement(S.SubTitle, null, subtitle),
                content && React.createElement(S.Content, null, content),
                cta?.url && React.createElement(S.Cta, null,
                    cta.text,
                    " >")))));
};
export default SignpostCard;
